angular.module('TetherApp').controller('ListenerListController', [
    '$window',
    '$location',
    '$anchorScroll',
    'listenerListService',
    '$scope',
    function (
        $window,
        $location,
        $anchorScroll,
        listenerListService,
        $scope
    ) {
        let self = this;
        self.listenerLists = [];
        self.listenerListsActions = [];

        self.init = function (lists) {
            self.lists = lists;
            if(window.listenerLists != undefined) {
                angular.forEach(window.listenerLists, function( value, key ) {
                    self.listenerLists.push(value);
                }, self);
            }

            if(window.listenerListsActions != undefined) {
                angular.forEach(window.listenerListsActions, function( value, key ) {
                    self.listenerListsActions.push(value);
                }, self);
            }
        };

        self.refresh = function(){
            // console.log(self.listenerLists);
        };

        self.updateNewListenerList = function() {
            angular.forEach(self.lists, function( value, key ) {
                if(value.id == self.listenerListSelected) {
                    self.listenerListSelectedName = value.name
                }
            }, self);

            angular.forEach(self.listenerListsActions, function( value, key ) {
                if(value.id == self.listenerListActionSelected) {
                    self.listenerListActionName = value.name
                }
            }, self);
        }

        self.createListenerList = function () {
            data = {};
            data.id = null;
            data.list_id = null;
            data.name = null;
            data.custom_list_expression = null;
            data.action = null;
            data.action_name = null;

            if (self.listenerListActionSelected != 2) {
                data.id = null;
                data.list_id = self.listenerListSelected;
                data.name = self.listenerListSelectedName;
                data.action = self.listenerListActionSelected;
                data.action_name = self.listenerListActionName;
            } else {
                data.id = null;
                data.list_id = null;
                data.name = self.customListExpression;
                data.custom_list_expression = self.customListExpression;
                data.action = self.listenerListActionSelected;
                data.action_name = self.listenerListActionName;
            }

            if(!data.action) {
                self.hasError = 1;
            }
            else if (data.action == 2 && !data.custom_list_expression) {
                self.hasError = 1;
            }
            else if (data.action != 2 && !data.list_id) {
                self.hasError = 1;
            }
            else {
                self.hasError = 0;

                if (data.action != 2) {
                    alreadyExists = false;

                    angular.forEach(self.listenerLists, function( value, key ) {
                        if(value.list_id == data.list_id) {
                            alreadyExists = true;
                        }
                    }, self);

                    if(!alreadyExists) {
                        self.listenerLists.push(
                            data
                        );
                    }
                } else {
                    self.listenerLists.push(
                        data
                    );
                }

                self.listenerListSelected = null;
                self.listenerListActionSelected = null;
                self.customListExpression = null;
            }
        };

        self.deleteListenerList = function(key) {
            self.listenerLists.splice(key, 1);
        };

        $scope.$on('bag-one.drop-model', function (e, el) {
            self.refresh();
        })

    }
]);
